import "../../../assets/RideIconButton.css";
import m, { forwardRef as y, cloneElement as d } from "react";
import f from "clsx";
const p = "_fill_192y2_29", g = "_glyph_192y2_32", v = "_outline_192y2_72", b = "_unfill_192y2_141", h = "_small_192y2_184", R = "_medium_192y2_191", x = "_large_192y2_198", l = {
  "ride-icon-button": "_ride-icon-button_192y2_1",
  fill: p,
  glyph: g,
  "fill-inverse": "_fill-inverse_192y2_49",
  outline: v,
  "outline-secondary": "_outline-secondary_192y2_94",
  "outline-inverse": "_outline-inverse_192y2_116",
  unfill: b,
  "unfill-inverse": "_unfill-inverse_192y2_161",
  small: h,
  medium: R,
  large: x
}, B = y(
  ({
    className: t,
    glyph: e,
    size: n = "small",
    type: i = "button",
    variant: o = "fill",
    "data-testid": r,
    ...s
  }, _) => {
    const u = () => f(
      t,
      l["ride-icon-button"],
      l[n],
      l[o]
    ), a = {
      large: "x-large",
      medium: "large",
      small: "medium"
    }, c = () => e ? d(e, {
      size: a[n],
      fill: "currentColor",
      className: l.glyph
    }) : null;
    return /* @__PURE__ */ m.createElement(
      "button",
      {
        ...s,
        ref: _,
        "data-testid": r,
        className: u(),
        type: i
      },
      c()
    );
  }
);
B.displayName = "RideIconButton";
export {
  B as RideIconButton
};
